import React, { useContext } from 'react';
import { Textarea, TextareaProps, Label } from '@rebass/forms';
import { useFormikContext } from 'formik';
import { Box } from 'rebass';

import { ErrorMessage } from './ErrorMessage';
import { FocusContext } from '../../../contexts/FocusContext';

export interface TextareaFieldProps extends TextareaProps {
  name: string;
  label: string;
  required?: boolean;
  validateOnBlur?: boolean;
  autoFocus?: boolean;
  'data-testid'?: string;
}

export const TextareaField: React.FC<TextareaFieldProps> = ({
  name,
  label,
  placeholder,
  required,
  validateOnBlur,
  onBlur,
  autoFocus = false,
  ...props
}) => {
  let { handleChange, handleBlur, values, errors, touched } = useFormikContext<
    any
  >();
  const { setFocus } = useContext(FocusContext);

  const hasError = !!touched[name] && errors && errors[name];
  const errorName = `errorFor${name[0].toUpperCase() + name.substr(1)}`;

  return (
    <Box>
      <Label htmlFor={name} variant="label">
        {label}
      </Label>

      <Textarea
        autoFocus={autoFocus}
        onFocus={() => setFocus(true)}
        onBlur={e => {
          setFocus(false);
          if (validateOnBlur) {
            handleBlur(e);
          }
          if (onBlur) onBlur(e);
        }}
        onChange={handleChange}
        aria-describedby={errorName}
        value={values[name]}
        name={name}
        id={name}
        aria-required={required}
        placeholder={placeholder}
        variant={hasError ? 'input.error' : 'input'}
        sx={{ height: 'auto' }}
        data-testid={props['data-testid']}
      />
      {hasError && (
        <ErrorMessage name={name} errors={errors} errorName={errorName} />
      )}
    </Box>
  );
};
